import { Controller } from "@hotwired/stimulus"

// Persist sidebar scroll position across Turbo navigations
let savedScrollTop = null

document.addEventListener("turbo:before-render", () => {
  const sidebar = document.querySelector("[data-openstax-toc-target='sidebar']")
  if (sidebar) {
    savedScrollTop = sidebar.scrollTop
  }
})

export default class extends Controller {
  static targets = ["sidebar", "chapter", "scrim"]

  toggleSidebar() {
    this.#setOpen(!this.sidebarTarget.classList.contains("open"))
  }

  toggleChapter(event) {
    const chapter = event.currentTarget.closest("[data-openstax-toc-target='chapter']")
    chapter.classList.toggle("open")
  }

  closeSidebar() {
    this.#setOpen(false)
  }

  disconnect() {
    this.#setOpen(false)
  }

  // Mobile overlay: the scrim behind the sidebar and a body class that locks
  // page scroll while it is open (both no-ops on desktop, where the sidebar
  // is always in view).
  #setOpen(open) {
    this.sidebarTarget.classList.toggle("open", open)
    if (this.hasScrimTarget) this.scrimTarget.classList.toggle("open", open)
    document.body.classList.toggle("sidebar-open", open)
    document.querySelectorAll("[aria-controls='openstaxSidebar'].reader-topbar-menu")
      .forEach((button) => button.setAttribute("aria-expanded", open))
  }

  connect() {
    const active = this.element.querySelector(".openstax-toc-page.active")
    if (!active) return

    const sidebar = this.sidebarTarget

    if (savedScrollTop !== null) {
      // Restore previous scroll position, then check if active is visible
      sidebar.scrollTop = savedScrollTop
      savedScrollTop = null

      const activeTop = active.offsetTop
      const activeBottom = activeTop + active.offsetHeight
      const visibleTop = sidebar.scrollTop
      const visibleBottom = visibleTop + sidebar.clientHeight

      if (activeTop < visibleTop || activeBottom > visibleBottom) {
        sidebar.scrollTop = activeTop - (sidebar.clientHeight / 2)
      }
    } else {
      // First load — center the active item
      sidebar.scrollTop = active.offsetTop - (sidebar.clientHeight / 2)
    }
  }
}
